import React from 'react';

import Input from './Input';

const SearchField = (props) => {
	const new_props = { ...props };
	new_props.classname = 'input text search';
	if(new_props.placeholder == undefined) new_props.placeholder = "Type to search";

	return (
		<Input {...new_props} />
	);
}

export default SearchField;